import { LockIcon } from '@curology/ui-components-web/react/Icon/icons/LockIcon';
import { Progress } from '@curology/ui-components-web/react/Progress';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { useStripeElement } from '@/components/payments/hooks/useStripeElement';

const CreditCardInput: React.FC = () => {
  const {
    inputErrorMessage,
    showCcInputLoader,
    ccInputContainerId,
    ccInputId,
  } = useStripeElement();

  return (
    <>
      <div
        className={`cur-border cur-border-solid cur-border-subtle cur-p-[18px] cur-leading-[0] cur-text-center${
          inputErrorMessage ? ' cur-border-error cur-border-[3px]' : ''
        }`}
      >
        <label className="cur-w-full" id={ccInputContainerId}>
          <div id={ccInputId} />
        </label>
        {showCcInputLoader && (
          <Progress
            className="cur-inline-block"
            progressType="circle"
            state="highlight"
          />
        )}
      </div>
      {inputErrorMessage && (
        <Typography className="cur-mt-2 cur-text-error" size="meta">
          {inputErrorMessage}
        </Typography>
      )}
      <Typography className="cur-flex cur-items-center cur-mt-4" size="meta">
        <LockIcon className="cur-mr-2" size="sm" />
        <span>Secured 256-bit TLS encrypted payment</span>
      </Typography>
    </>
  );
};

export default CreditCardInput;
